import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { NgForm } from '@angular/forms';
import { AuthenticationService } from './../../_services/authentication.service';
import { first } from 'rxjs/operators';
import { ToastrService } from 'ngx-toastr';
import { Subscription } from 'rxjs';
import { LoaderService } from '../../_services/loader.service';

@Component({
  selector: 'app-dashboard',
  templateUrl: './verify-otp.component.html'
})
export class VerifyOTPComponent implements OnInit {
	// loading = false;
	model: any = {};
	subscription: Subscription;
	email = localStorage.getItem("otpEmail");
	password = localStorage.getItem("otpPassword");

	constructor( private authenticationService: AuthenticationService, 
		private route: ActivatedRoute, 
		private router: Router, 
		private toastr: ToastrService,
		private loader: LoaderService) {
	}

  	ngOnInit() {
		  // Restrict subadmin to direct access OTP screen without login
		  if (!this.email) {
			this.router.navigate(['/login']);
		  }
  	}

  	onSubmit(frm: NgForm) {
  		// stop here if form is invalid
	    if (frm.invalid) {
	        return;
	    }
    	this.loader.showLoader();
  		this.authenticationService.verifyOTP({
				activation_code: this.model.otp,
				email: this.email,
				password: this.password
		}).pipe(first())
	      .subscribe(
	          data => {
				this.loader.hideLoader();
				if (data.meta.status) {
					this.authenticationService.setLoggedIn(true);
					this.toastr.success(data.meta.message);
					this.router.navigate(['/dashboard']);
				}
	          },
	          error => {
				this.loader.hideLoader();
	            const errorData = error;
				const self = this;
				if (errorData && errorData.meta) {
					if (errorData.meta.message_code === 'VALIDATION_ERROR') {
						for (const key in errorData.errors) {
							if (key) {
							self.toastr.error(errorData.errors[key][0]);
							}
						}
					} else {
						self.toastr.error(errorData.meta.message);
					}
				} else {
					this.toastr.error('Something went wrong please try again.');
				}
	    });

	  }
	  resendOTP() {
		this.loader.showLoader();
  		this.authenticationService.login(this.email, this.password)
	      .pipe(first())
	      .subscribe(
	          data => {
				this.loader.hideLoader();
	              	if (data.meta.status) {
						this.toastr.success(data.meta.message);
	              	}
	          },
	          error => {
				this.loader.hideLoader();
	            const errorData = error;
				const self = this;
				if (errorData && errorData.meta) {
					if (errorData.meta.message_code === 'VALIDATION_ERROR') {
						for (const key in errorData.errors) {
							if (key) {
							self.toastr.error(errorData.errors[key][0]);
							}
						}
					} else {
						self.toastr.error(errorData.meta.message);
					}
				} else {
					this.toastr.error('Something went wrong please try again.');
				}
	    });
	  }
}
